import JobQuotePricesDeposit from './JobQuotePricesDeposit';
import JobQuotePricesSimple from './JobQuotePricesSimple';
import useJobQuotePrices from './useJobQuotePrices';

const JobQuotePrices: React.FunctionComponent = function () {
  const {
    type,
    subTotal,
    vatTotal,
    jobTotal,
    depositAmount,
    totalToPay,
    gridClassName,
    variant,
    isLoading,
  } = useJobQuotePrices();
  return (
    <div className={gridClassName}>
      {type === 'deposit' ? (
        <JobQuotePricesDeposit
          subTotal={subTotal}
          vatTotal={vatTotal}
          jobTotal={jobTotal}
          depositAmount={depositAmount}
          totalToPay={totalToPay}
          variant={variant}
          isLoading={isLoading}
        />
      ) : (
        <JobQuotePricesSimple
          subTotal={subTotal}
          vatTotal={vatTotal}
          jobTotal={jobTotal}
          variant={variant}
          isLoading={isLoading}
        />
      )}
    </div>
  );
};

export default JobQuotePrices;
